module.exports = __webpack_public_path__ + "assets/svg/plyr-cc94d8dd3656bc7b0c843c2fcf5c55a3.svg";


//////////////////
// WEBPACK FOOTER
// ./fk.app/_src/vendors/plyr-master/dist/plyr.svg
// module id = 27
// module chunks = 0